export default __webpack_public_path__ + "static/media/gallery-img6.eed7c88a.jpeg";